import gaOperationCoreInstanceEn from "./instance/default";
import pagesGAOperationCoreOperationPackagesEn from "./operation-packages/default";

const pagesGAOperationCoreEn = {
  operationPackages: pagesGAOperationCoreOperationPackagesEn,
  instance: gaOperationCoreInstanceEn,
};

export default pagesGAOperationCoreEn;
